import React from "react";
//
import { SurveyRichText } from "../survey-rich-text/survey-rich-text";
// Styling
import { UnstyledButton } from "@mantine/core";

import clsx from "clsx";
import css from "./options-button.module.css";
// types
import type { SurveyEngineIface } from "src/services/surveyHooks/useSurveyEngine";
import type { TranslationKey } from "@neuromotion-inc/mightier-survey-engine";

interface OptionButtonProps<T = string | boolean> {
  value: T;
  labelTranslationKey: TranslationKey;
  surveyEngine: SurveyEngineIface;
  onChange: (value: T) => void;
  onBlur: () => void;
  isValueSelected: boolean;
}

export const OptionButton = React.memo<OptionButtonProps>(
  function OptionButton({
    value,
    labelTranslationKey,
    surveyEngine,
    isValueSelected,
    onChange,
    onBlur,
  }) {
    const handleClick = (event: React.MouseEvent<HTMLButtonElement>): void => {
      // Apparently Safari doesn't automatically focus on buttons onClick so need to manually do it
      // https://stackoverflow.com/questions/61245883/why-blur-and-focus-doesnt-work-on-safari
      event.currentTarget.focus(); // Focus on button onClick
      onChange(value);
    };

    const buttonStyle = clsx(
      css.button,
      isValueSelected && css["button--selected"],
    );

    return (
      <UnstyledButton
        className={buttonStyle}
        variant={isValueSelected ? "filled" : "outline"}
        onClick={handleClick}
        onBlur={onBlur}
        data-testid={`option-button-${value}`}
      >
        <SurveyRichText
          className={css["button-text"]}
          surveyEngine={surveyEngine}
          text={labelTranslationKey}
        />
      </UnstyledButton>
    );
  },
);
